
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFileExportGoogle as ObiFileExportGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-file-export-google.js';
 
 
 

 
 export const ObiFileExportGoogle = createComponent({
   react: React,
   tagName: 'obi-file-export-google',
   elementClass: ObiFileExportGoogleElement,
   events: {
     
   }
  });
 
 